export default "__VITE_ASSET__B7zA13F$__"